module.exports = __webpack_public_path__ + "img/dispositivos.55dc6b0b.svg";